import { useTranslation } from "react-i18next";
import { Button, Dialog, Text } from "react-native-paper";
import DialogWrapper from "../DialogWrapper";

type Props = {
	visible: boolean;
	handleClose: () => void;
	numItemsRequested: number;
	numItemsAvailable: number;
};

const moreItemsAlertTemplate = ({
	numItemsRequested,
	numItemsAvailable,
}: {
	numItemsRequested: number;
	numItemsAvailable: number;
}) => {
	return `Due to the way that certain items are grouped together (e.g., passages/scenarios), your study session will be ${numItemsAvailable} items long rather than the ${numItemsRequested} that you requested`;
};

const MoreItemsAlertDialog = ({
	visible,
	handleClose,
	numItemsAvailable,
	numItemsRequested,
}: Props) => {
	const { t } = useTranslation();
	const body = moreItemsAlertTemplate({
		numItemsAvailable,
		numItemsRequested,
	});

	return (
		<DialogWrapper visible={visible} handleClose={handleClose} maxWidth={"xs"}>
			<Dialog.Icon icon={"information-outline"} />
			<Dialog.Title
				style={{
					textAlign: "center",
				}}
			>
				{t("session.moreItemsAlertDialog.title")}
			</Dialog.Title>
			<Dialog.Content>
				<Text variant="bodyMedium">{body}</Text>
			</Dialog.Content>

			<Dialog.Actions>
				<Button onPress={handleClose}>
					{t("session.moreItemsAlertDialog.cta")}
				</Button>
			</Dialog.Actions>
		</DialogWrapper>
	);
};

export default MoreItemsAlertDialog;
